import { motion } from 'motion/react';
import { useRouter } from 'next/router';
import { GLOBAL_OPENER_DELAY } from '@/src/constants/delay';

const BouncingFootball = ({ className = '', id = '', width = 32, height = 32, delay = 0.5 }) => {
  const { locale } = useRouter();

  return (
    <motion.svg
      className={className || 'absolute'}
      initial={{ y: 0, width, height, scaleX: 1, scaleY: 1, opacity: 0 }}
      animate={['show', 'drop', 'rotate']}
      variants={{
        show: {
          opacity: [0, 1],
          transition: {
            delay: delay + GLOBAL_OPENER_DELAY,
          },
        },
        drop: {
          scaleX: [0.7, 1],
          scaleY: [1.3, 1],
          y: [-16, 0],
          transition: {
            duration: 2,
            delay: delay + GLOBAL_OPENER_DELAY,
            bounce: 0.92,
            type: 'spring',
          },
        },
        rotate: {
          rotateZ: locale === 'ar' ? -150 : 200,
          transition: {
            duration: 1.2,
            delay: delay + GLOBAL_OPENER_DELAY,
            type: 'keyframes',
          },
        },
      }}
      exit={{
        opacity: 0,
        x: locale === 'ar' ? -400 : 400,
        y: [0, -10, 40],
      }}
      viewBox='0 0 450.16989 478.26294'
    >
      <defs>
        <linearGradient id={`d-${id}`}>
          <stop offset='0' stopColor='#333' />
          <stop offset='1' stopColor='#333' stopOpacity='0' />
        </linearGradient>
        <linearGradient id={`f-${id}`}>
          <stop offset='0' stopColor='#6a6a6a' />
          <stop offset='1' />
        </linearGradient>
        <linearGradient id={`e-${id}`}>
          <stop offset='0' stopColor='#fff' />
          <stop offset='.47019866' stopColor='#fff' />
          <stop offset='1' stopColor='#d6d6d6' />
        </linearGradient>
        <linearGradient id={`b-${id}`}>
          <stop offset='0' />
          <stop offset='1' stopOpacity='0' />
        </linearGradient>
        <linearGradient id={`a-${id}`}>
          <stop offset='0' />
          <stop offset='1' stopOpacity='0' />
        </linearGradient>
        <linearGradient id={`c-${id}`}>
          <stop offset='0' stopColor='#333' />
          <stop offset='1' stopOpacity='0' />
        </linearGradient>
        <linearGradient
          xlinkHref={`#a-${id}`}
          id={`k-${id}`}
          x1='237.34625'
          x2='125.4752'
          y1='1070.5031'
          y2='1026.626'
          gradientTransform='translate(173.33769 -492.30712) scale(.9748)'
          gradientUnits='userSpaceOnUse'
        />
        <linearGradient
          xlinkHref={`#b-${id}`}
          id={`j-${id}`}
          x1='350.87286'
          x2='468.47543'
          y1='1121.9573'
          y2='1143.9006'
          gradientTransform='translate(179.46599 -490.16078) scale(.9741)'
          gradientUnits='userSpaceOnUse'
        />
        <linearGradient
          xlinkHref={`#c-${id}`}
          id={`l-${id}`}
          x1='299.17374'
          x2='320.48227'
          y1='952.46429'
          y2='882.12744'
          gradientTransform='translate(218.71638 -432.34392) scale(.87835)'
          gradientUnits='userSpaceOnUse'
        />
        <radialGradient
          xlinkHref={`#d-${id}`}
          id={`g-${id}`}
          cx='253.14085'
          cy='470.03119'
          r='114.36129'
          fx='253.14085'
          fy='470.03119'
          gradientTransform='matrix(1 0 0 .19711 0 377.3826)'
          gradientUnits='userSpaceOnUse'
        />
        <radialGradient
          xlinkHref={`#e-${id}`}
          id={`i-${id}`}
          cx='311.42657'
          cy='1062.9181'
          r='225.0625'
          fx='311.42657'
          fy='1062.9181'
          gradientTransform='matrix(1 0 0 1.00007 167.18189 -512.69731)'
          gradientUnits='userSpaceOnUse'
        />
        <radialGradient
          xlinkHref={`#f-${id}`}
          id={`h-${id}`}
          cx='317.61365'
          cy='207.49344'
          r='245.83293'
          fx='317.61365'
          fy='207.49344'
          gradientTransform='translate(211.22283 370.35026) scale(.83833)'
          gradientUnits='userSpaceOnUse'
        />
      </defs>
      <g transform='translate(-236.97296 -366.478)'>
        <path
          fill={`url(#g-${id})`}
          fillRule='evenodd'
          d='M366.00214 470.03119a112.86129 21.041935 0 1 1-225.72258 0 112.86129 21.041935 0 1 1 225.72258 0z'
          overflow='visible'
          style={{ marker: 'none' }}
          transform='matrix(1.76703 0 0 3.28947 -6.8918733 -770.63016)'
        />
        <path
          fill={`url(#h-${id})`}
          fillRule='evenodd'
          d='M687.14286 591.56295c0 124.24689-100.83806 225.08495-225.08495 225.08495-124.2469 0-225.08495-100.83806-225.08495-225.08495 0-124.2469 100.83805-225.08495 225.08495-225.08495 124.24689 0 225.08495 100.83805 225.08495 225.08495z'
          overflow='visible'
          style={{ marker: 'none' }}
        />
        <path
          fill={`url(#i-${id})`}
          fillRule='evenodd'
          d='M462.04847 366.48162c-49.12805 0-94.57643 15.78496-131.59375 42.53125-16.11579 19.48961-27.40625 39-27.40625 39l-20.5625 7.875c-28.55882 37.73568-45.5 84.74822-45.5 135.6875 0 4.75815.14614 9.47117.4375 14.15625 5.11583 9.13972 8.9375 14.96874 8.9375 14.96875l-2.625 25.6875c14.70149 58.67954 52.4553 108.24261 103.0625 138.5 3.61585 2.3383 6.63613 3.7538 9.95419 5.6308-1.76052-1.6631-2.30279-2.108-3.45419-3.162-13.2473-13.7018-24.40625-29.7188-24.40625-29.7188l32.03125-29.46875c.00001.00001 20.59409 15.56507 43.71875 23.625 23.12467 8.05995 48.78125 8.62495 48.78125 8.62495l15.875 40.75s-14.02787 7.1945-33.9375 10.7188c-3.56519.6311-7.333 1.1444-11.09375 1.5625 12.288 2.0813 24.90327 3.1875 37.78125 3.1875 52.04257 0 99.99002-17.684 138.125-47.375 11.92991-15.98524 19.75001-29.71876 19.75-29.71875l17.375-6.8125c30.83273-38.2231 49.436-86.71943 49.8125-139.53125-6.12407-18.15827-12.81249-28.81248-12.8125-28.8125 0 0 1.70719-16.58244-.69064-34.84754-.37624-2.86596 1.54952-1.846 3.86731-3.40223-.68742-2.5948-3.18496-10.30609-4.44499-13.98838-4.96028-14.49589-9.83936-21.41177-13.04418-27.82435 6.24328 3.48764-.02453-.01889-.03125-.03125-38.13036-70.16276-112.48651-117.81251-197.90625-117.8125zm27.21875 8.5625c18.70387.25577 38.21875 6.3125 38.21875 6.3125-.00001-.00003 22.17311 8.52059 38 20.5625 15.8269 12.0419 25.3125 27.59375 25.3125 27.59375l-40.25 27.8125c.00001-.00003-21.66626-14.84249-44.3125-22.84375-22.64623-8.00125-46.28125-9.15625-46.28125-9.15625l-11.40625-41.53125c-.00001 0 17.2634-8.11024 37-8.71875 1.23354-.03803 2.47183-.0483 3.71875-.03125zm-131.53125 111.1875c13.82046.0635 25.3125 1.71875 25.3125 1.71875l20.8125 88.4375-66.8125 63.625s-20.86317-13.23662-35.90625-26.1875-24.28125-25.625-24.28125-25.625c.00001 0 2.71584-25.65389 8.84375-47.71875 6.12791-22.06487 15.6875-40.53125 15.6875-40.53125.00001.00001 16.51864-9.50668 36.9375-12.5 6.38089-.93542 13.12422-1.24761 19.40625-1.21875zm216.53125 63.15625c-.00001 0 18.83767 8.25331 34.03125 20.40625 15.19356 12.15293 26.75 28.21875 26.75 28.21875s-1.07773 22.00055-8.34375 44.875c-7.26606 22.87442-20.71875 46.625-20.71875 46.625-.00001-.00002-18.77755 6.89075-38.59375 8.75-19.81621 1.85925-40.6875-1.3125-40.6875-1.3125l-10.34375-43.28125-10.65625-44.5s14.14166-17.05226 31.28125-32c17.13958-14.94775 37.28125-27.78125 37.28125-27.78125z'
          overflow='visible'
          style={{ marker: 'none' }}
        />
        <path
          fill='none'
          stroke={`url(#j-${id})`}
          strokeLinejoin='round'
          strokeWidth='4.87051201'
          d='M633.37377 598.67637s-1.05853 21.44345-8.13637 43.7255c-7.07787 22.28204-20.17505 45.40273-20.17505 45.40273s-18.2965 6.72426-37.5995 8.53537c-19.30303 1.81108-39.61253-1.29098-39.61253-1.29098l-10.08838-42.15011-10.37144-43.33281s13.77207-16.63224 30.46778-31.19286c16.6957-14.56064 36.31506-27.04965 36.31506-27.04965s18.34722 8.05197 33.14732 19.89019c14.80012 11.8382 26.05311 27.46262 26.05311 27.46262z'
          overflow='visible'
          style={{ marker: 'none' }}
        />
        <path
          fill='none'
          stroke={`url(#k-${id})`}
          strokeLinejoin='round'
          strokeWidth='4.87402344'
          d='M337.13219 638.06303s-20.33709-12.90572-35.00115-25.5303c-14.66406-12.62458-23.6551-24.96801-23.6551-24.96801s2.63677-24.99641 8.61028-46.50533c5.97351-21.50895 15.28378-39.5304 15.28378-39.5304s16.09843-9.25504 36.00283-12.17294c19.9044-2.91792 43.61477.50133 43.61477.50133l20.2793 86.21081-65.13471 61.99484z'
          overflow='visible'
          style={{ marker: 'none' }}
        />
        <path
          fill='none'
          stroke={`url(#l-${id})`}
          strokeWidth='5.01581049'
          d='M526.54287 385.59247s19.46417 7.49626 33.36569 18.07324c13.90152 10.57698 22.24039 24.23473 22.24039 24.23473l-35.3569 24.43107s-19.03147-13.05403-38.92281-20.08194c-19.89128-7.02791-47.71344-9.79746-47.71344-9.79746l-9.3194-36.84304s19.39501-6.76894 36.73059-7.30338c17.33567-.53453 38.97588 7.28678 38.97588 7.28678z'
          overflow='visible'
          style={{ marker: 'none' }}
        />
        <path
          fill='none'
          stroke='#666'
          d='M382.00558 489.15386s36.18673-48.08059 78.43673-64.33059'
        />
        <path
          fill='none'
          stroke='#ececec'
          strokeWidth='3'
          d='M552.77779 456.09916s26.98483 42.92633 23.48483 91.92633'
        />
        <path
          fill='none'
          stroke='#666'
          d='M550.3743 456.61356s27.57582 44.37608 24.07582 93.37608m13.34835-120.73959S647.58179 452.85 673.83179 527.6m-38.41481 70.28856s21.04441-1.63477 39.42918-32.74745m-54.45245 174.17926s2.92081-18.12891-14.52125-50.95295m-152.20474 72.56685s32.35014-8.57367 73.36233-65.14227m-190.21172-56.56852s-1.94454 50.38132 23.15775 89.97932m-31.09977 28.70185s-7.42957.09236-35.54505-16.85775m-15.99829-152.91191s-20.14855 8.46346-31.00149 31.91127M302.69795 448.248s-7.23157 27.91231-.94794 51.36314m25.16883-87.01538s60.05418-50.89505 121.21891-28.26764m21.01181 416.88934s52.38635 13.45104 133.18737-34.23303'
        />
        <path
          fill='none'
          stroke='#f2f2f2'
          strokeLinecap='square'
          strokeWidth='3'
          d='M382.20012 485.5451s30.09054-41.4415 74.34054-61.3165'
        />
        <path
          fill='none'
          stroke='#fff'
          strokeWidth='3'
          d='M454.49019 762.66727s30.8224-5.9461 71.83459-62.51467m-191.53234-59.80964s-1.94454 50.39572 23.15775 89.99372'
        />
        <path
          fill='none'
          stroke='#999'
          d='M404.34702 576.55614s26.33973 6.18718 101.29305 32.70369'
          overflow='visible'
          style={{ marker: 'none' }}
        />
        <path
          fill='none'
          stroke='#ececec'
          d='M404.34702 575.28087s26.33973 6.18718 101.29305 32.70369'
          overflow='visible'
          style={{ marker: 'none' }}
        />
      </g>
    </motion.svg>
  );
};

export default BouncingFootball;
